import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getItemsToDisplayIds from './get-items-to-display-ids';
import { OR, OR_OPERATOR, KEYWORD } from '../constants';
import buildCheckboxFilters from './build-checkbox-filters';
const buildFilterValues = (listFilterValues, relations, stringProps) => {
  const listFilterValuesKeys = Object.keys(listFilterValues);
  return listFilterValuesKeys.map(key => {
    const values = listFilterValues[key].map(el => {
      let updatedKey = key;
      const isRelation = key.includes('.');
      if (isRelation) {
        const [relationName, relationProp] = key.split('.');
        const [relation] = relations.filter(({
          localField
        }) => localField === relationName);
        const {
          entityIdentifier = ''
        } = relation || {};
        if (entityIdentifier && entityIdentifier !== relationName) updatedKey = `${entityIdentifier}.${relationProp}`;
      }
      const fieldName = stringProps.includes(updatedKey) ? `${key}.${KEYWORD}` : key;
      return {
        match: {
          [fieldName]: el
        }
      };
    });
    return {
      bool: {
        should: values
      }
    };
  });
};
const buildItemsToDisplayValues = itemsToDisplay => {
  if (!itemsToDisplay || !itemsToDisplay.length) return [];
  const itemToDisplayIds = getItemsToDisplayIds(itemsToDisplay);
  return [{
    ids: {
      values: itemToDisplayIds
    }
  }];
};
const buildShouldValues = docTypes => {
  if (Array.isArray(docTypes)) {
    return docTypes.map(docType => ({
      match: {
        docType
      }
    }));
  }
  return [{
    match: {
      docType: docTypes
    }
  }];
};
const buildRawQueryBase = ({
  docType,
  id,
  filterValues: {
    checkboxFilters = [],
    listFilterValues = {}
  } = {},
  filterOperator,
  relations,
  stringProps,
  itemsToDisplay,
  addListFiltersToQuery = false
}) => {
  const listFilterFinalValues = buildFilterValues(listFilterValues, relations, stringProps);
  const checkboxFiltersValue = buildCheckboxFilters(checkboxFilters);
  const itemsToDisplayValues = buildItemsToDisplayValues(itemsToDisplay);
  const isOperatorOr = filterOperator === OR;
  const queryFilters = [];
  const baseBoolObject = {
    should: buildShouldValues(docType),
    minimum_should_match: 1,
    must: [...itemsToDisplayValues, ...checkboxFiltersValue]
  };
  if (isOperatorOr) {
    if (addListFiltersToQuery) {
      queryFilters.push(...listFilterFinalValues);
    } else {
      baseBoolObject.must.push({
        bool: {
          [OR_OPERATOR]: [...listFilterFinalValues]
        }
      });
    }
  } else {
    baseBoolObject.must.push(...listFilterFinalValues);
  }
  const mustNot = id ? [{
    ids: {
      values: [id]
    }
  }] : undefined;
  const queryFilter = queryFilters.length ? {
    [OR_OPERATOR]: queryFilters,
    minimum_should_match: 1
  } : {};
  return _objectSpread(_objectSpread({}, queryFilter), {}, {
    filter: {
      bool: baseBoolObject
    },
    must_not: mustNot
  });
};
export default buildRawQueryBase;
//# sourceMappingURL=build-raw-query-base.js.map